@if(isPreviewing() && prescriptionToPrintId()) {
<!-- PRINT PREVIEW MODE (Full Screen) -->
<div
    class="print-preview-container bg-slate-500 fixed inset-0 z-[100] p-4 sm:p-8 print:p-0 print:bg-white pb-32 overflow-y-auto">
    <app-prescription-form [prescriptionId]="prescriptionToPrintId()!"></app-prescription-form>
</div>

<div class="fixed bottom-0 left-0 right-0 bg-slate-900 border-t border-slate-700 p-3 shadow-lg z-[101] no-print">
    <div class="max-w-screen-xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-3">
        <div class="text-white">
            <p class="font-bold text-emerald-400">ตัวอย่างก่อนพิมพ์ (Print Preview)</p>
        </div>
        <div class="flex gap-3 w-full sm:w-auto">
            <button (click)="exitPreviewMode()"
                class="flex-1 sm:flex-none bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg font-bold transition-colors">
                <i class="fa-solid fa-times mr-2"></i> ปิด
            </button>
            <button (click)="downloadImage()" [disabled]="isGeneratingImage()"
                class="flex-1 sm:flex-none bg-purple-600 hover:bg-purple-500 text-white px-6 py-3 rounded-lg font-bold shadow-lg flex items-center justify-center gap-2 disabled:opacity-50">
                @if(isGeneratingImage()) { <i class="fa-solid fa-spinner animate-spin"></i><span>กำลังสร้าง...</span> }
                @else { <i class="fa-solid fa-image"></i><span>บันทึก PNG</span> }
            </button>
            <button (click)="printSmartly()" [disabled]="isGeneratingImage()"
                class="flex-1 sm:flex-none bg-blue-600 hover:bg-blue-500 text-white px-8 py-3 rounded-lg font-bold shadow-lg flex items-center justify-center gap-2 disabled:opacity-50">
                @if(isGeneratingImage()) { <i class="fa-solid fa-spinner animate-spin"></i> }
                @else { <i class="fa-solid fa-print"></i> }
                <span>พิมพ์ (Print)</span>
            </button>
        </div>
    </div>
</div>
} @else {
<div class="h-full w-full bg-slate-900 text-white flex flex-col font-sans overflow-hidden relative">

    <!-- Top Bar -->
    <header
        class="flex justify-between items-center p-4 bg-slate-800/80 backdrop-blur border-b border-slate-700 z-50 flex-shrink-0 relative">
        <div class="flex items-center gap-3 min-w-0">
            <div
                class="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center shadow-lg shadow-emerald-500/20 flex-shrink-0">
                <i class="fa-solid fa-hospital-user text-2xl"></i>
            </div>
            <div class="overflow-hidden min-w-0">
                <h1 class="font-bold text-lg leading-tight truncate">{{ 'pos.kiosk.title' | translate }}</h1>
                <p class="text-xs text-slate-400 truncate">{{ 'pos.kiosk.subtitle' | translate }}</p>
            </div>
        </div>
        @if(currentUser(); as user) {
        <div class="text-right flex items-center gap-4 flex-shrink-0">
            <div class="hidden sm:block">
                <p class="font-semibold text-sm">{{ user.name }}</p>
                <p class="text-xs text-slate-400 capitalize">{{ user.role }}</p>
            </div>
            <button routerLink="/admin/dashboard"
                class="bg-slate-700 hover:bg-slate-600 px-3 py-1.5 rounded-md text-xs font-bold transition-colors whitespace-nowrap">
                <i class="fa-solid fa-chart-pie mr-1"></i> Admin
            </button>
        </div>
        }
    </header>

    <!-- Content Area -->
    <main
        class="flex-grow flex flex-col items-center justify-center sm:p-6 relative overflow-y-auto w-full overflow-x-hidden">

        <!-- BACKGROUND DECORATION -->
        <div class="absolute inset-0 z-0 opacity-5 pointer-events-none overflow-hidden hidden sm:block">
            <i class="fa-solid fa-user-doctor absolute bottom-10 left-0 text-[20rem] transform translate-x-[-20%]"></i>
            <i class="fa-solid fa-file-medical absolute top-20 right-0 text-[15rem] transform translate-x-[20%]"></i>
        </div>

        <!-- LOADING RESTORE -->
        @if(isRestoring()) {
        <div class="z-20 flex flex-col items-center justify-center animate-fade-in text-center p-4">
            <i class="fa-solid fa-rotate-right animate-spin text-5xl text-blue-500 mb-4"></i>
            <h2 class="text-xl sm:text-2xl font-bold">{{ 'pos.kiosk.restoring' | translate }}</h2>
        </div>
        } @else {

        <!-- SHARED FILE INPUT (Hidden) -->
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" class="hidden"
            aria-label="File Upload for OCR or ID Card">

        <!-- STEP 2: KYC -->
        @if(currentStep() === 'kyc') {
        <div
            class="z-10 w-full sm:max-w-5xl bg-white text-slate-800 sm:rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up flex flex-col flex-grow sm:flex-grow-0 h-full sm:h-auto sm:min-h-[500px]">
            <!-- Header -->
            <div class="bg-slate-100 p-4 border-b flex justify-between items-center flex-shrink-0">
                <h2 class="text-lg sm:text-2xl font-bold flex items-center gap-2"><i
                        class="fa-solid fa-id-card text-blue-600"></i> <span class="truncate">{{ 'pos.kiosk.kyc.title' |
                        translate }}</span></h2>
                <span class="bg-slate-200 px-3 py-1 rounded-full text-xs font-bold text-slate-500 whitespace-nowrap">{{
                    'pos.kiosk.kyc.stepLabel' | translate }}</span>
            </div>

            <div class="flex-grow flex flex-col md:flex-row overflow-hidden">
                <!-- Left Panel: Input Method Selection -->
                <div
                    class="w-full md:w-1/3 bg-slate-50 p-4 border-b md:border-b-0 md:border-r border-slate-200 flex flex-col gap-3 flex-shrink-0 overflow-y-auto max-h-[30vh] md:max-h-none">
                    <h3 class="font-bold text-base sm:text-lg text-slate-700">{{ 'pos.kiosk.kyc.selectMethod' |
                        translate }}</h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-2">

                        <!-- HIDDEN BUTTONS: CARD READER & OCR (AI)
                            <button (click)="selectInputMethod('card')" [class]="'p-3 rounded-xl border-2 text-left flex items-center gap-3 transition-all ' + (inputMethod() === 'card' ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-md' : 'border-slate-200 hover:bg-white')">
                                <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0"><i class="fa-solid fa-usb text-sm"></i></div>
                                <div class="overflow-hidden min-w-0">
                                    <div class="font-bold text-sm truncate">{{ 'pos.kiosk.kyc.methodCard' | translate }}</div>
                                    <div class="text-[10px] opacity-70 truncate hidden md:block">{{ 'pos.kiosk.kyc.methodCardDesc' | translate }}</div>
                                </div>
                            </button> 
                            END HIDDEN BUTTONS -->
                        <button (click)="selectInputMethod('ocr')"
                            [class]="'p-3 rounded-xl border-2 text-left flex items-center gap-3 transition-all ' + (inputMethod() === 'ocr' ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-md' : 'border-slate-200 hover:bg-white')">
                            <div
                                class="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 flex-shrink-0">
                                <i class="fa-solid fa-camera text-sm"></i></div>
                            <div class="overflow-hidden min-w-0">
                                <div class="font-bold text-sm truncate">{{ 'pos.kiosk.kyc.methodOcr' | translate }}
                                </div>
                                <div class="text-[10px] opacity-70 truncate hidden md:block">{{
                                    'pos.kiosk.kyc.methodOcrDesc' | translate }}</div>
                            </div>
                        </button>


                        <button (click)="selectInputMethod('manual')"
                            [class]="'p-3 rounded-xl border-2 text-left flex items-center gap-3 transition-all ' + (inputMethod() === 'manual' ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-md' : 'border-slate-200 hover:bg-white')">
                            <div
                                class="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-slate-600 flex-shrink-0">
                                <i class="fa-solid fa-keyboard text-sm"></i></div>
                            <div class="overflow-hidden min-w-0">
                                <div class="font-bold text-sm truncate">{{ 'pos.kiosk.kyc.methodManual' | translate }}
                                </div>
                                <div class="text-[10px] opacity-70 truncate hidden md:block">{{
                                    'pos.kiosk.kyc.methodManualDesc' | translate }}</div>
                            </div>
                        </button>
                    </div>
                    @if(statusMessage() && inputMethod() !== 'ocr') {
                    <div
                        class="mt-2 md:mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-xs sm:text-sm animate-pulse flex items-center">
                        <i class="fa-solid fa-circle-notch animate-spin mr-2"></i> {{ statusMessage() }}
                    </div>
                    }
                </div>

                <!-- Right Panel: Dynamic Content Area -->
                <div class="w-full md:w-2/3 p-4 flex flex-col h-full overflow-hidden relative">
                    @if(inputMethod() === 'card' || (isLoading() && (inputMethod() !== 'ocr'))) {
                    <div class="flex-grow flex flex-col items-center justify-center text-center p-4">
                        <i class="fa-solid fa-id-card-clip text-6xl sm:text-8xl text-slate-200 mb-6 animate-pulse"></i>
                        <h3 class="text-lg sm:text-xl font-bold text-slate-600">{{ 'pos.kiosk.kyc.statusWaiting' |
                            translate }}</h3>
                        <p class="text-slate-400 text-sm">{{ 'pos.kiosk.kyc.methodCardDesc' | translate }}</p>
                        <button (click)="simulateSmartCardRead()" class="mt-8 text-blue-500 underline text-sm">{{
                            'pos.kiosk.kyc.statusSim' | translate }}</button>
                    </div>
                    } @else if(inputMethod() === 'ocr') {
                    <div
                        class="flex-grow flex flex-col items-center justify-center bg-black rounded-xl overflow-hidden relative group min-h-[250px] w-full">
                        <video #videoElement autoplay playsinline
                            class="w-full h-full object-cover absolute inset-0"></video>
                        <div
                            class="absolute inset-0 border-2 border-white/30 m-4 sm:m-8 rounded-lg pointer-events-none flex flex-col justify-between p-4">
                            <div class="flex justify-between">
                                <div class="w-10 h-10 border-t-4 border-l-4 border-white"></div>
                                <div class="w-10 h-10 border-t-4 border-r-4 border-white"></div>
                            </div>
                            <div class="flex justify-between">
                                <div class="w-10 h-10 border-b-4 border-l-4 border-white"></div>
                                <div class="w-10 h-10 border-b-4 border-r-4 border-white"></div>
                            </div>
                        </div>
                        @if(statusMessage() && !isLoading()) {
                        <div
                            class="absolute inset-0 flex items-center justify-center z-20 bg-black/50 backdrop-blur-[2px] animate-fade-in">
                            <div
                                class="bg-white text-slate-800 px-6 py-4 rounded-xl shadow-2xl flex flex-col items-center gap-2 max-w-xs text-center border-2 border-orange-400">
                                <i class="fa-solid fa-camera-rotate text-3xl text-orange-500 mb-1"></i>
                                <span class="font-bold text-lg">{{ statusMessage() }}</span>
                            </div>
                        </div>
                        } @else if(!ocrError() && !isLoading()) {
                        <div
                            class="absolute top-10 bg-black/50 text-white px-4 py-2 rounded-full backdrop-blur-sm text-sm font-medium animate-pulse pointer-events-none">
                            วางบัตรให้อยู่ในกรอบ (Place ID Card in Frame)
                        </div>
                        }
                        @if(isLoading()) {
                        <div
                            class="absolute inset-0 bg-black/60 flex flex-col items-center justify-center z-20 backdrop-blur-sm">
                            <div class="relative w-20 h-20">
                                <div class="absolute inset-0 border-4 border-white/20 rounded-full"></div>
                                <div class="absolute inset-0 border-4 border-t-emerald-500 rounded-full animate-spin">
                                </div>
                            </div>
                            <p class="mt-4 text-white font-bold text-lg tracking-wide">กำลังประมวลผล...</p>
                        </div>
                        }
                        @if(!isLoading()) {
                        <div class="absolute bottom-6 flex gap-6 items-center pointer-events-auto z-10">
                            <button (click)="backToMethodSelection()" aria-label="Close camera and return"
                                class="bg-black/40 hover:bg-black/60 text-white w-12 h-12 rounded-full backdrop-blur flex items-center justify-center transition-colors border border-white/20"><i
                                    class="fa-solid fa-xmark"></i></button>
                            <button (click)="captureForOCR()" aria-label="Scan ID Card with camera"
                                class="w-20 h-20 rounded-full border-4 border-white flex items-center justify-center shadow-lg bg-white/20 hover:bg-white/40 transition-all transform active:scale-95">
                                <div class="w-16 h-16 bg-white rounded-full"></div>
                            </button>
                            <button (click)="triggerFileUpload('ocr')"
                                aria-label="Upload an image instead of using camera"
                                class="bg-black/40 hover:bg-black/60 text-white w-12 h-12 rounded-full backdrop-blur flex items-center justify-center transition-colors border border-white/20"
                                title="Upload an image instead"><i class="fa-solid fa-upload"></i></button>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex-grow space-y-3 overflow-y-auto pb-4 pr-1">
                        <div class="relative">
                            <label for="customer-search-kiosk" class="block text-xs font-bold text-slate-700 mb-1">{{
                                'modals.customerForm.name' | translate }} <span class="text-red-500">*</span></label>
                            <input id="customer-search-kiosk" #searchInput type="text" [ngModel]="searchTerm()"
                                (ngModelChange)="onSearchInput($event)" (focus)="onSearchFocus()"
                                (blur)="onSearchBlur()" [disabled]="inputMethod() !== 'manual'"
                                placeholder="ค้นหาผู้ป่วยเก่า หรือ พิมพ์ชื่อใหม่..." autocomplete="off"
                                class="w-full p-3 border rounded-lg bg-slate-50 font-bold focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all text-sm">

                            @if(isDropdownOpen() && inputMethod() === 'manual') {
                            <div
                                class="absolute z-20 w-full mt-1 bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                                @if(customersLoadingError()) {
                                <div class="p-3 text-red-500 text-sm">
                                    <i class="fa-solid fa-circle-xmark mr-2"></i> {{ customersLoadingError() }}
                                </div>
                                } @else if (allCustomers().length === 0) {
                                <div class="p-3 text-slate-500 text-sm text-center">
                                    ไม่มีข้อมูลผู้ป่วยในระบบ
                                </div>
                                } @else {
                                @for(customer of filteredCustomers(); track customer.id) {
                                <div (mousedown)="selectCustomer(customer)"
                                    class="px-4 py-3 text-slate-700 hover:bg-emerald-100 cursor-pointer border-b last:border-b-0">
                                    <p class="font-semibold">{{ customer.fullName }}</p>
                                    <p class="text-xs text-slate-500 font-mono">{{ customer.phone || 'No phone' }} | HN:
                                        {{ customer.hn || 'N/A' }}</p>
                                </div>
                                } @empty {
                                <div class="p-4 text-slate-500 text-sm text-center">
                                    ไม่พบข้อมูล "{{searchTerm()}}".<br>
                                    <span class="text-xs">กรอกข้อมูลต่อเพื่อลงทะเบียนใหม่</span>
                                </div>
                                }
                                }
                            </div>
                            }
                        </div>
                        <div>
                            <label for="citizenId-input" class="block text-xs font-bold text-slate-700 mb-1">{{
                                'modals.customerForm.nationalId' | translate }} <span
                                    class="text-red-500">*</span></label>
                            <!-- ADDED MASK HERE -->
                            <input appInputMask="citizen-id" id="citizenId-input" type="text"
                                [ngModel]="scannedCustomer().citizenId"
                                (ngModelChange)="updateCustomerField('citizenId', $event)"
                                [disabled]="inputMethod() !== 'manual' && !!scannedCustomer().citizenId"
                                class="w-full p-3 border rounded-lg bg-slate-50 font-mono text-sm">
                        </div>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div>
                                <label for="birthDate-input" class="block text-xs font-bold text-slate-700 mb-1">{{
                                    'modals.customerForm.dob' | translate }} <span class="text-red-500">*</span></label>
                                <input id="birthDate-input" type="date" [ngModel]="scannedCustomer().birthDate"
                                    (ngModelChange)="updateCustomerField('birthDate', $event)"
                                    [disabled]="inputMethod() !== 'manual' && !!scannedCustomer().birthDate"
                                    class="w-full p-3 border rounded-lg bg-slate-50 text-sm">
                                @if(computedAge() !== null) {
                                @if(isUnderage()) {
                                <div
                                    class="text-red-600 text-xs font-bold mt-1 bg-red-50 p-2 rounded border border-red-200 animate-pulse">
                                    <i class="fa-solid fa-circle-exclamation"></i> อายุต่ำกว่า 20 ปี ({{computedAge()}}
                                    ปี)</div>
                                } @else {
                                <div class="text-green-600 text-xs font-bold mt-1"><i
                                        class="fa-solid fa-check-circle"></i> อายุผ่านเกณฑ์ ({{computedAge()}} ปี)</div>
                                }
                                }
                            </div>
                            <div>
                                <label for="phone-input" class="block text-xs font-bold text-slate-700 mb-1">{{
                                    'modals.customerForm.phone' | translate }} <span
                                        class="text-red-500">*</span></label>
                                <!-- ADDED MASK HERE -->
                                <input appInputMask="phone" #phoneInput id="phone-input" type="tel"
                                    [ngModel]="scannedCustomer().phone"
                                    (ngModelChange)="updateCustomerField('phone', $event)"
                                    class="w-full p-3 border-2 border-blue-100 rounded-lg focus:border-blue-500 outline-none transition-colors text-sm"
                                    placeholder="0XX-XXX-XXXX">
                            </div>
                        </div>
                        <div>
                            <label for="address-input"
                                class="block text-xs font-bold text-slate-700 mb-1">Address</label>
                            <textarea id="address-input" [ngModel]="scannedCustomer().address"
                                (ngModelChange)="updateCustomerField('address', $event)" rows="2"
                                [disabled]="inputMethod() !== 'manual' && !!scannedCustomer().address"
                                class="w-full p-3 border rounded-lg bg-slate-50 text-xs"></textarea>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <!-- Footer Buttons -->
            <div class="p-4 bg-slate-50 border-t flex justify-between flex-shrink-0">
                <button (click)="resetForm()"
                    class="px-4 sm:px-6 py-3 rounded-lg font-bold text-slate-500 hover:bg-slate-200 text-sm">เริ่มใหม่</button>
                <button (click)="goToIdCardPhotoStep()"
                    [disabled]="!scannedCustomer().fullName || !scannedCustomer().citizenId || !scannedCustomer().birthDate || !scannedCustomer().phone || isUnderage()"
                    class="px-4 sm:px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center gap-2 disabled:bg-slate-300 disabled:cursor-not-allowed text-sm transition-all">
                    {{ 'pos.kiosk.kyc.next' | translate }} <i class="fa-solid fa-arrow-right"></i>
                </button>
            </div>
        </div>
        }

        <!-- STEP 2.5: AI-ASSISTED KYC REVIEW -->
        @if(currentStep() === 'kyc-review') {
        <div
            class="z-10 w-full sm:max-w-5xl bg-white text-slate-800 sm:rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up flex flex-col flex-grow sm:flex-grow-0 h-full sm:h-auto sm:min-h-[500px]">
            <!-- Header -->
            <div class="bg-slate-100 p-4 border-b flex justify-between items-center flex-shrink-0">
                <h2 class="text-lg sm:text-2xl font-bold flex items-center gap-2"><i
                        class="fa-solid fa-user-pen text-blue-600"></i> <span class="truncate">ตรวจสอบข้อมูลที่ AI
                        อ่านได้</span></h2>
                <span
                    class="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">AI-Assisted
                    Review</span>
            </div>

            <div class="flex-grow flex flex-col md:flex-row overflow-hidden">
                <!-- Left Panel: ID Card Image -->
                <div
                    class="w-full md:w-1/2 bg-slate-100 p-4 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r">
                    <h3 class="font-bold text-base text-slate-500 mb-2">รูปภาพบัตรประชาชน</h3>
                    @if(capturedIdCardImage()) {
                    <img [src]="capturedIdCardImage()" alt="ID Card Scan for review"
                        class="max-w-full max-h-80 rounded-lg shadow-lg border-2 border-white">
                    } @else {
                    <div class="w-full h-60 bg-slate-200 rounded-lg flex items-center justify-center text-slate-400">No
                        Image</div>
                    }
                </div>

                <!-- Right Panel: Editable Form -->
                <div class="w-full md:w-1/2 p-4 sm:p-6 flex flex-col h-full overflow-hidden">
                    <div class="flex-grow space-y-3 overflow-y-auto pb-4 pr-1">
                        <div>
                            <label for="review-fullName-input"
                                class="block text-xs font-bold text-slate-700 mb-1">ชื่อ-นามสกุล (Full Name) <span
                                    class="text-red-500">*</span></label>
                            <input id="review-fullName-input" type="text" [ngModel]="scannedCustomer().fullName"
                                (ngModelChange)="updateCustomerField('fullName', $event)"
                                class="w-full p-3 border rounded-lg bg-slate-50 font-bold focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all text-sm">
                        </div>
                        <div>
                            <label for="review-citizenId-input"
                                class="block text-xs font-bold text-slate-700 mb-1">เลขบัตรประชาชน (Citizen ID) <span
                                    class="text-red-500">*</span></label>
                            <!-- ADDED MASK HERE -->
                            <input appInputMask="citizen-id" id="review-citizenId-input" type="text"
                                [ngModel]="scannedCustomer().citizenId"
                                (ngModelChange)="updateCustomerField('citizenId', $event)"
                                class="w-full p-3 border rounded-lg bg-slate-50 font-mono text-sm">
                        </div>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div>
                                <label for="review-birthDate-input"
                                    class="block text-xs font-bold text-slate-700 mb-1">วันเกิด (Date of Birth) <span
                                        class="text-red-500">*</span></label>
                                <input id="review-birthDate-input" type="date" [ngModel]="scannedCustomer().birthDate"
                                    (ngModelChange)="updateCustomerField('birthDate', $event)"
                                    class="w-full p-3 border rounded-lg bg-slate-50 text-sm"
                                    [class.border-red-500]="!scannedCustomer().birthDate"
                                    [class.border-2]="!scannedCustomer().birthDate">
                                @if(!scannedCustomer().birthDate) {
                                <p class="text-xs text-red-600 mt-1 font-semibold animate-pulse">กรุณากรอกข้อมูลวันเกิด
                                </p>
                                }
                            </div>
                            <div>
                                <label for="review-phone-input"
                                    class="block text-xs font-bold text-slate-700 mb-1">เบอร์โทรศัพท์ (Phone) <span
                                        class="text-red-500">*</span></label>
                                <!-- ADDED MASK HERE -->
                                <input appInputMask="phone" id="review-phone-input" type="tel"
                                    [ngModel]="scannedCustomer().phone"
                                    (ngModelChange)="updateCustomerField('phone', $event)"
                                    class="w-full p-3 border rounded-lg focus:border-blue-500 outline-none transition-colors text-sm"
                                    placeholder="0XX-XXX-XXXX">
                            </div>
                        </div>
                        <div>
                            <label for="review-address-input"
                                class="block text-xs font-bold text-slate-700 mb-1">ที่อยู่ (Address)</label>
                            <textarea id="review-address-input" [ngModel]="scannedCustomer().address"
                                (ngModelChange)="updateCustomerField('address', $event)" rows="2"
                                class="w-full p-3 border rounded-lg bg-slate-50 text-xs"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Buttons -->
            <div class="p-4 bg-slate-50 border-t flex justify-between flex-shrink-0">
                <button (click)="backToMethodSelection()"
                    class="px-4 sm:px-6 py-3 rounded-lg font-bold text-slate-500 hover:bg-slate-200 text-sm">สแกนใหม่
                    (Re-Scan)</button>
                <button (click)="goToIdCardPhotoStep()"
                    [disabled]="!scannedCustomer().fullName || !scannedCustomer().citizenId || !scannedCustomer().birthDate || !scannedCustomer().phone || isUnderage()"
                    class="px-4 sm:px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center gap-2 disabled:bg-slate-300 disabled:cursor-not-allowed text-sm transition-all">
                    ยืนยันและไปต่อ <i class="fa-solid fa-arrow-right"></i>
                </button>
            </div>
        </div>
        }

        <!-- STEP 2.8: ID CARD PHOTO CAPTURE -->
        @if(currentStep() === 'id-card-photo') {
        <div
            class="z-10 w-full sm:max-w-2xl bg-white text-slate-800 sm:rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up flex flex-col flex-grow sm:flex-grow-0 h-full sm:h-auto sm:max-h-[85vh]">
            <div class="bg-slate-100 p-4 border-b flex justify-between items-center flex-shrink-0">
                <h2 class="text-lg sm:text-2xl font-bold flex items-center gap-2"><i
                        class="fa-solid fa-id-card text-blue-600"></i> ถ่ายรูปบัตรประชาชน</h2>
                <span class="bg-slate-200 px-3 py-1 rounded-full text-xs font-bold text-slate-500">ขั้นตอนที่ 2/5</span>
            </div>

            <div class="p-4 sm:p-8 flex flex-col items-center overflow-y-auto flex-grow justify-center">

                @if((existingIdCardUrl() || '').trim() && !capturedIdCardImage() && !isRetakingIdCard()) {
                <!-- SHOW EXISTING PHOTO VIEW -->
                <div class="mb-6 text-center">
                    <p class="text-sm text-slate-500 mb-2">รูปบัตรประชาชนในระบบ:</p>
                    <div
                        class="relative w-full max-w-lg aspect-video bg-slate-100 rounded-lg overflow-hidden shadow-md">
                        <img [src]="existingIdCardUrl()" alt="Existing ID Card photo on file"
                            class="w-full h-full object-cover">
                    </div>
                </div>
                <div class="flex flex-col sm:flex-row gap-4 w-full justify-center">
                    <button (click)="retakeIdCard()"
                        class="w-full sm:w-auto px-6 py-3 bg-slate-200 rounded-lg font-bold text-slate-700 hover:bg-slate-300 text-sm">
                        <i class="fa-solid fa-camera mr-2"></i> ถ่ายใหม่ (Retake)
                    </button>
                    <button (click)="goToPatientPhotoStep()"
                        class="w-full sm:w-auto px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center justify-center gap-2 text-sm">
                        ใช้รูปเดิม (Use Existing) <i class="fa-solid fa-check"></i>
                    </button>
                </div>
                } @else {
                <!-- CAMERA VIEW -->
                <p class="text-sm text-slate-500 mb-4 text-center">กรุณาถ่ายรูปบัตรประชาชนเพื่อเก็บเป็นหลักฐาน (Please
                    take a photo of the ID card for records)</p>
                <div
                    class="relative w-full max-w-lg aspect-video bg-black rounded-lg overflow-hidden shadow-inner mb-6">
                    @if(capturedIdCardImage()) {
                    <img [src]="capturedIdCardImage()" alt="Captured ID card photo" class="w-full h-full object-cover">
                    } @else {
                    <video #videoElement autoplay playsinline class="w-full h-full object-cover"></video>
                    <div
                        class="absolute inset-0 border-2 border-dashed border-white/50 m-8 rounded-lg pointer-events-none">
                    </div>
                    }
                </div>

                @if(!capturedIdCardImage()) {
                <div class="flex gap-4">
                    <button (click)="captureIdCardAndProceed()" aria-label="Capture ID Card Photo"
                        class="w-16 h-16 sm:w-20 sm:h-20 bg-blue-600 rounded-full border-4 border-white shadow-xl hover:scale-110 transition-transform flex items-center justify-center">
                        <i class="fa-solid fa-camera text-white text-2xl"></i>
                    </button>
                    <button (click)="triggerFileUpload('idcard')" aria-label="Upload ID Card from file"
                        class="w-16 h-16 sm:w-20 sm:h-20 bg-slate-700 rounded-full border-4 border-white shadow-xl hover:scale-110 transition-transform flex items-center justify-center"
                        title="Upload Image">
                        <i class="fa-solid fa-upload text-white text-2xl"></i>
                    </button>
                </div>
                } @else {
                <div class="flex gap-4 justify-center w-full">
                    <button (click)="retakeIdCard()"
                        class="px-6 py-3 bg-slate-200 rounded-lg font-bold text-slate-700 hover:bg-slate-300 text-sm">ถ่ายใหม่</button>
                    <button (click)="goToPatientPhotoStep()"
                        class="px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center gap-2 text-sm">
                        ใช้รูปนี้ (Confirm) <i class="fa-solid fa-check"></i>
                    </button>
                </div>
                }
                }
            </div>
        </div>
        }

        <!-- STEP 3: PHOTO -->
        @if(currentStep() === 'photo') {
        <div
            class="z-10 w-full sm:max-w-2xl bg-white text-slate-800 sm:rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up flex flex-col flex-grow sm:flex-grow-0 h-full sm:h-auto sm:max-h-[85vh]">
            <div class="bg-slate-100 p-4 border-b flex justify-between items-center flex-shrink-0">
                <h2 class="text-lg sm:text-2xl font-bold flex items-center gap-2"><i
                        class="fa-solid fa-user-check text-blue-600"></i> {{ 'pos.kiosk.photo.title' | translate }}</h2>
                <span class="bg-slate-200 px-3 py-1 rounded-full text-xs font-bold text-slate-500">ขั้นตอนที่ 3/5</span>
            </div>

            <div class="p-4 sm:p-8 flex flex-col items-center overflow-y-auto flex-grow justify-center">

                @if (existingPhotoUrl() && !capturedPhoto() && !isRetakingPhoto()) {
                <!-- Show existing photo -->
                <div class="mb-6 text-center">
                    <p class="text-sm text-slate-500 mb-2">รูปภาพปัจจุบันในระบบ:</p>
                    <div
                        class="relative w-full max-w-sm aspect-[3/4] bg-slate-100 rounded-lg overflow-hidden shadow-md">
                        <img [src]="existingPhotoUrl()" alt="Existing Patient Photo" class="w-full h-full object-cover">
                    </div>
                </div>
                <div class="flex flex-col sm:flex-row gap-4 w-full justify-center">
                    <button (click)="retakePhoto()"
                        class="w-full sm:w-auto px-6 py-3 bg-slate-200 rounded-lg font-bold text-slate-700 hover:bg-slate-300 text-sm">ถ่ายรูปใหม่
                        (Update Photo)</button>
                    <button (click)="confirmAndGoToSymptoms()"
                        class="w-full sm:w-auto px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center justify-center gap-2 text-sm">
                        {{ 'pos.kiosk.photo.confirm' | translate }} <i class="fa-solid fa-check"></i>
                    </button>
                </div>

                } @else {
                <!-- Camera View -->
                <div class="relative w-full max-sm aspect-[3/4] bg-black rounded-lg overflow-hidden shadow-inner mb-6">
                    @if(capturedPhoto()) {
                    <img [src]="capturedPhoto()" alt="Captured patient photo" class="w-full h-full object-cover">
                    } @else {
                    <video #videoElement autoplay playsinline
                        class="w-full h-full object-cover transform scale-x-[-1]"></video>
                    <div
                        class="absolute inset-0 border-2 border-dashed border-white/50 m-8 rounded-full pointer-events-none flex items-center justify-center">
                    </div>
                    }
                </div>

                @if(!capturedPhoto()) {
                <div class="flex gap-4">
                    <button (click)="captureImage()" aria-label="Capture patient photo"
                        class="w-16 h-16 sm:w-20 sm:h-20 bg-red-500 rounded-full border-4 border-white shadow-xl hover:scale-110 transition-transform flex items-center justify-center">
                        <i class="fa-solid fa-camera text-white text-2xl"></i>
                    </button>
                </div>
                <p class="text-sm text-slate-400 mt-4 text-center">{{ 'pos.kiosk.photo.instruction' | translate }}</p>
                } @else {
                <div class="flex gap-4 w-full justify-center">
                    <button (click)="retakePhoto()"
                        class="px-6 py-3 bg-slate-200 rounded-lg font-bold text-slate-700 hover:bg-slate-300 text-sm">{{
                        'pos.kiosk.photo.retake' | translate }}</button>
                    <button (click)="confirmAndGoToSymptoms()"
                        class="px-8 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 shadow-lg flex items-center justify-center gap-2 text-sm">
                        {{ 'pos.kiosk.photo.confirm' | translate }} <i class="fa-solid fa-check"></i>
                    </button>
                </div>
                }
                }
            </div>
        </div>
        }

        <!-- STEP 4: SYMPTOMS & VITALS -->
        @if(currentStep() === 'symptoms') {
        <div
            class="z-10 w-full sm:max-w-3xl bg-white text-slate-800 sm:rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up flex flex-col flex-grow sm:flex-grow-0 h-full sm:h-auto sm:max-h-[85vh]">
            <div class="bg-slate-100 p-4 border-b flex justify-between items-center flex-shrink-0">
                <h2 class="text-lg sm:text-2xl font-bold flex items-center gap-2"><i
                        class="fa-solid fa-notes-medical text-blue-600"></i> <span class="truncate">{{
                        'pos.kiosk.symptoms.title' | translate }}</span></h2>
                <span
                    class="bg-slate-200 px-3 py-1 rounded-full text-xs font-bold text-slate-500 whitespace-nowrap">ขั้นตอนที่
                    4/5</span>
            </div>

            <div class="p-4 sm:p-6 overflow-y-auto flex-grow">
                <!-- Symptoms Section -->
                <div class="mb-6">
                    <p class="mb-3 text-slate-600 font-semibold">{{ 'pos.kiosk.symptoms.question' | translate }}</p>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                        @for(sym of symptomOptions; track sym) {
                        <button (click)="toggleSymptom(sym)"
                            [class]="'p-3 sm:p-4 rounded-xl border-2 text-left transition-all flex justify-between items-center ' + (selectedSymptoms().includes(sym) ? 'border-blue-500 bg-blue-50 text-blue-800 shadow-md transform scale-[1.02]' : 'border-slate-200 hover:border-blue-200 text-slate-600')">
                            <span class="text-sm font-semibold">{{ sym }}</span>
                            @if(selectedSymptoms().includes(sym)) { <i
                                class="fa-solid fa-circle-check text-blue-500"></i> }
                        </button>
                        }
                    </div>

                    @if(selectedSymptoms().includes('อื่นๆ (Other)')) {
                    <div class="animate-fade-in">
                        <label for="other-symptom-input" class="block text-sm font-bold text-slate-700 mb-1">{{
                            'pos.kiosk.symptoms.other' | translate }}</label>
                        <input id="other-symptom-input" type="text" [(ngModel)]="otherSymptomText"
                            class="w-full p-3 border-2 border-blue-200 rounded-lg focus:border-blue-500 outline-none"
                            [placeholder]="'pos.kiosk.symptoms.otherPlaceholder' | translate" autofocus>
                    </div>
                    }
                </div>

                <!-- Vital Signs Section -->
                <div class="pt-6 border-t">
                    <h3 class="text-base font-bold text-slate-700 mb-3 flex items-center gap-2"><i
                            class="fa-solid fa-heart-pulse text-red-500"></i> ข้อมูลสุขภาพและสัญญาณชีพ (Vital Signs)
                    </h3>
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                        <div><label for="vitals-temp" class="block text-xs font-bold text-slate-500 mb-1">อุณหภูมิ
                                (°C)</label><input id="vitals-temp" type="number" step="0.1"
                                [(ngModel)]="vitals_temperature_c" placeholder="e.g., 36.5"
                                class="w-full border-slate-300 rounded p-2 text-sm text-center"></div>
                        <div><label for="vitals-pulse" class="block text-xs font-bold text-slate-500 mb-1">ชีพจร
                                (ครั้ง/นาที)</label><input id="vitals-pulse" type="number"
                                [(ngModel)]="vitals_pulse_rate" placeholder="e.g., 80"
                                class="w-full border-slate-300 rounded p-2 text-sm text-center"></div>
                        <div><label for="vitals-resp" class="block text-xs font-bold text-slate-500 mb-1">อัตราหายใจ
                                (ครั้ง/นาที)</label><input id="vitals-resp" type="number"
                                [(ngModel)]="vitals_respiration_rate" placeholder="e.g., 18"
                                class="w-full border-slate-300 rounded p-2 text-sm text-center"></div>
                        <div><label for="vitals-bp" class="block text-xs font-bold text-slate-500 mb-1">ความดัน
                                (มม.ปรอท)</label><input id="vitals-bp" type="text" [(ngModel)]="vitals_blood_pressure"
                                placeholder="e.g., 120/80"
                                class="w-full border-slate-300 rounded p-2 text-sm text-center"></div>
                        <div><label for="vitals-weight" class="block text-xs font-bold text-slate-500 mb-1">น้ำหนัก
                                (กก.)</label><input id="vitals-weight" type="number" step="0.1"
                                [(ngModel)]="vitals_weight_kg" placeholder="e.g., 75.5"
                                class="w-full border-slate-300 rounded p-2 text-sm text-center"></div>
                        <div><label for="vitals-height" class="block text-xs font-bold text-slate-500 mb-1">ส่วนสูง
                                (ซม.)</label><input id="vitals-height" type="number" [(ngModel)]="vitals_height_cm"
                                placeholder="e.g., 170" class="w-full border-slate-300 rounded p-2 text-sm text-center">
                        </div>
                    </div>
                </div>

                <div
                    class="bg-amber-50 p-4 rounded-lg border border-amber-200 text-xs sm:text-sm text-amber-800 mt-6 flex gap-3">
                    <input type="checkbox" [(ngModel)]="consentGiven" id="consent-checkbox"
                        class="mt-1 w-5 h-5 text-amber-600 rounded focus:ring-amber-500 flex-shrink-0" required
                        aria-label="Consent to terms and privacy policy">
                    <label for="consent-checkbox">
                        ข้าพเจ้ายินยอมให้เปิดเผยข้อมูลสุขภาพและภาพถ่ายเพื่อการวินิจฉัย และรับทราบ
                        <a (click)="openPrivacyModal('tos')"
                            class="underline font-bold hover:text-amber-900 cursor-pointer">ข้อตกลงการใช้บริการ</a> และ
                        <a (click)="openPrivacyModal('pdpa')"
                            class="underline font-bold hover:text-amber-900 cursor-pointer">นโยบายความเป็นส่วนตัว</a>
                    </label>
                </div>
            </div>

            <div class="p-4 bg-slate-50 border-t flex justify-between flex-shrink-0">
                <button (click)="currentStep.set('photo')"
                    class="px-4 sm:px-6 py-3 rounded-lg font-bold text-slate-500 hover:bg-slate-200 text-sm">{{
                    'pos.kiosk.kyc.back' | translate }}</button>
                <button (click)="initiateSubmission()"
                    [disabled]="isLoading() || selectedSymptoms().length === 0 || !consentGiven"
                    class="px-4 sm:px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-bold hover:shadow-xl transition-all flex items-center gap-3 text-sm sm:text-lg disabled:opacity-70 disabled:cursor-not-allowed">
                    @if(isLoading()) { <i class="fa-solid fa-spinner animate-spin"></i> }
                    @if(authService.currentStore()?.businessType === 'DISPENSARY' && !hasInHouseDoctor()) {
                    <span>เลือกคลินิกและส่งตัว</span>
                    } @else {
                    <span>{{ 'pos.kiosk.symptoms.confirm' | translate }}</span>
                    }
                    <i class="fa-solid fa-paper-plane"></i>
                </button>
            </div>
        </div>
        }

        <!-- STEP 5: WAITING ROOM -->
        @if(currentStep() === 'waiting') {
        <div class="z-10 text-center animate-fade-in flex flex-col items-center w-full px-4 py-8 relative">

            <!-- Connection Status -->
            <div
                class="bg-slate-800/80 backdrop-blur rounded-full px-4 py-1.5 text-xs font-bold text-emerald-400 border border-emerald-500/30 mb-8 flex items-center gap-2 animate-pulse z-20">
                <i class="fa-solid fa-wifi"></i> {{ (isCallAccepted() ? 'กำลังเชื่อมต่อกับแพทย์...' :
                ('pos.kiosk.waiting.status' | translate)) }}
            </div>

            <!-- Pulsing Status Icon -->
            <div class="w-32 h-32 sm:w-40 sm:h-40 relative mb-8 z-10">
                <div class="absolute inset-0 bg-blue-500 rounded-full animate-ping opacity-20 pointer-events-none">
                </div>

                @if(roomName()) {
                <!-- RINGING/IN-CALL STATE -->
                <div class="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75 pointer-events-none">
                </div>
                <div class="absolute inset-2 bg-green-600 rounded-full flex items-center justify-center shadow-2xl z-20"
                    [class.animate-bounce]="!isCallAccepted()">
                    @if(isCallAccepted()) {
                    <i class="fa-solid fa-headset text-5xl sm:text-6xl text-white"></i>
                    } @else {
                    <i class="fa-solid fa-phone-volume text-5xl sm:text-6xl text-white"></i>
                    }
                </div>
                } @else {
                <!-- WAITING STATE -->
                <div class="absolute inset-2 bg-white rounded-full flex items-center justify-center shadow-2xl z-20">
                    <i class="fa-solid fa-user-doctor text-5xl sm:text-6xl text-blue-600"></i>
                </div>
                }
            </div>

            <h2 class="text-2xl sm:text-4xl font-bold mb-4 z-20 relative">
                {{ isCallAccepted() ? 'กำลังสนทนากับแพทย์' : ('pos.kiosk.waiting.title' | translate) }}
            </h2>
            <p class="text-lg sm:text-xl text-blue-300 mb-8 z-20 relative">
                {{ isCallAccepted() ? 'กรุณาปฏิบัติตามคำแนะนำของแพทย์ผ่านหน้าต่าง VDO' : callStatus() }}
            </p>

            @if(roomName() && !isCallAccepted()) {
            <button (click)="joinIncomingCall()"
                class="mb-8 bg-green-500 hover:bg-green-600 text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg animate-pulse flex items-center gap-3 transition-all hover:scale-105 relative z-50 cursor-pointer pointer-events-auto">
                <i class="fa-solid fa-video"></i> {{ 'pos.kiosk.waiting.joinCall' | translate }}
            </button>
            } @else if (isCallAccepted()) {
            <button (click)="isCallModalOpen.set(true)"
                class="mb-8 bg-slate-700 hover:bg-slate-600 text-white py-3 px-8 rounded-full border border-slate-500 text-sm font-bold transition-all relative z-50">
                <i class="fa-solid fa-external-link-alt mr-2"></i> เปิดหน้าต่างวิดีโออีกครั้ง
            </button>
            }

            <!-- Customer Info Card -->
            <div
                class="bg-slate-800/50 p-6 rounded-xl border border-slate-600 max-w-md w-full text-left relative z-20 mb-8">
                <div class="flex items-center gap-4 mb-4 pb-4 border-b border-slate-700">
                    <div class="w-12 h-12 bg-slate-700 rounded-full flex items-center justify-center flex-shrink-0"><i
                            class="fa-solid fa-user text-xl"></i></div>
                    <div class="overflow-hidden min-w-0">
                        <p class="font-bold text-lg truncate">{{ scannedCustomer().fullName }}</p>
                        <p class="text-sm text-slate-400">ID: {{ scannedCustomer().citizenId }}</p>
                    </div>
                </div>
                <p class="text-sm text-slate-400 mb-2">{{ 'pos.kiosk.symptoms.title' | translate }}:</p>
                <div class="flex flex-wrap gap-2">
                    @for(s of selectedSymptoms(); track s) {
                    <span class="bg-slate-700 px-3 py-1 rounded-full text-sm">{{ s }}</span>
                    }
                </div>
            </div>

            <!-- CANCEL BUTTON -->
            <div class="fixed bottom-8 left-1/2 -translate-x-1/2 z-[200] w-full max-w-md px-4 flex justify-center">
                @if(showCancelConfirm()) {
                <div
                    class="bg-red-900 border border-red-500 rounded-full p-2 flex items-center gap-3 shadow-2xl animate-fade-in">
                    <span class="text-white font-bold pl-4 text-sm whitespace-nowrap">ยืนยันการยกเลิก?</span>
                    <button (click)="confirmCancel()"
                        class="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm">ใช่
                        (Yes)</button>
                    <button (click)="abortCancel()"
                        class="bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-full font-bold text-sm">ไม่
                        (No)</button>
                </div>
                } @else {
                <button (click)="requestCancel()"
                    class="px-8 py-4 bg-slate-800 border border-red-500/30 text-red-400 hover:bg-red-900/20 hover:text-red-300 rounded-full text-sm transition-all font-semibold shadow-lg flex items-center justify-center cursor-pointer pointer-events-auto">
                    <i class="fa-solid fa-times-circle mr-2"></i> {{ 'pos.kiosk.waiting.cancel' | translate }}
                </button>
                }
            </div>
        </div>
        }

        <!-- STEP 5.5: REJECTED -->
        @if(currentStep() === 'rejected') {
        <div class="z-10 text-center animate-fade-in flex flex-col items-center justify-center w-full px-4 h-full">
            <div
                class="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mb-6 border border-red-500/50">
                <i class="fa-solid fa-circle-xmark text-6xl text-red-500"></i>
            </div>
            <h2 class="text-3xl font-bold mb-4 text-white">คำขอถูกปฏิเสธ (Request Rejected)</h2>
            <div class="bg-red-900/30 border border-red-800 p-6 rounded-xl max-w-md w-full mb-8">
                <p class="text-red-200 text-sm font-bold uppercase mb-2">เหตุผล (Reason):</p>
                <p class="text-xl text-white">{{ rejectionReason() }}</p>
            </div>
            <button (click)="finishSession()"
                class="px-8 py-4 bg-white text-slate-900 rounded-full font-bold text-lg hover:bg-slate-200 transition-colors shadow-lg flex items-center gap-2">
                <i class="fa-solid fa-rotate-right"></i> ลงทะเบียนใหม่ (Start Over)
            </button>
        </div>
        }

        <!-- STEP 6: COMPLETED -->
        @if(currentStep() === 'completed' && completedPrescription(); as presc) {
        <div
            class="z-10 w-full max-w-lg bg-white text-slate-800 rounded-2xl shadow-2xl overflow-hidden animate-bounce-in mx-4 my-8">
            <div class="bg-green-600 p-8 text-center text-white">
                <div
                    class="w-20 h-20 bg-white rounded-full flex items-center justify-center text-green-600 text-4xl mx-auto mb-4 shadow-lg">
                    <i class="fa-solid fa-file-contract"></i>
                </div>
                <h2 class="text-2xl sm:text-3xl font-bold">{{ 'pos.kiosk.completed.title' | translate }}</h2>
                <p class="opacity-90 mt-2">{{ 'pos.kiosk.completed.subtitle' | translate }}</p>
            </div>

            <div class="p-8 text-center">
                <p class="text-lg text-slate-600 mb-6">{{ 'pos.kiosk.completed.instruction' | translate }}</p>
                <div class="bg-green-50 p-4 rounded-xl border border-green-100 mb-6 text-left flex items-center gap-4">
                    <img src="https://api.qrserver.com/v1/create-qr-code/?size=80x80&data={{presc.id}}" alt="Cert QR"
                        class="w-16 h-16 mix-blend-multiply flex-shrink-0">
                    <div class="overflow-hidden min-w-0">
                        <p class="text-xs text-gray-500">{{ 'pos.kiosk.completed.certId' | translate }}</p>
                        <p class="font-mono font-bold text-lg text-green-800 truncate">{{ presc.id.substring(0,8) |
                            uppercase }}</p>
                        <p class="text-xs text-gray-500 truncate">{{ 'pos.kiosk.completed.approvedBy' | translate }} {{
                            presc.doctorName }}</p>
                    </div>
                </div>

                <div class="flex flex-col sm:flex-row gap-3 mb-4">
                    <!-- ปุ่มบันทึกภาพ -->
                    <button (click)="downloadImage()" [disabled]="isGeneratingImage()"
                        class="flex-1 py-4 bg-purple-600 text-white rounded-xl font-bold text-lg hover:bg-purple-700 shadow-lg flex items-center justify-center gap-2 transition-all active:scale-95 disabled:opacity-50">
                        <i class="fa-solid fa-image"></i>
                        <span>{{ 'pos.kiosk.completed.saveImage' | translate }}</span>
                    </button>

                    <!-- ปุ่มพิมพ์ -->
                    <button (click)="enterPreviewMode()"
                        class="flex-1 py-4 bg-slate-800 text-white rounded-xl font-bold text-lg hover:bg-slate-700 shadow-lg flex items-center justify-center gap-2 transition-all active:scale-95">
                        <i class="fa-solid fa-print"></i>
                        <span>{{ 'pos.kiosk.completed.print' | translate }}</span>
                    </button>
                </div>

                <button (click)="finishSession()" class="text-slate-500 hover:text-slate-800 font-semibold">
                    {{ 'pos.kiosk.completed.finish' | translate }}
                </button>
            </div>

            <!-- Hidden form for capturing image while on success screen -->
            <div class="fixed left-[-9999px] top-[-9999px] pointer-events-none opacity-0">
                <app-prescription-form [prescriptionId]="presc.id"></app-prescription-form>
            </div>
        </div>
        }
        }
    </main>
</div>

<app-video-call-modal [isOpen]="isCallModalOpen()" [isIncoming]="true" [twilioToken]="twilioToken()"
    [roomName]="roomName()" [displayName]="scannedCustomer().fullName || 'Patient'" (callEnded)="handleCallEnded()"
    (imageCaptured)="null">
</app-video-call-modal>

<app-privacy-policy-modal [isOpen]="isPrivacyModalOpen()" [initialTab]="initialPolicyTab()"
    (closeModal)="closePrivacyModal()" (accept)="handlePolicyAcceptance()">
</app-privacy-policy-modal>

<!-- REFERRAL SELECTION MODAL -->
@if (showReferralModal()) {
<div class="fixed inset-0 bg-black/80 flex items-center justify-center z-[3000] backdrop-blur-sm animate-fade-in"
    (click)="showReferralModal.set(false)">
    <div class="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden m-4" (click)="$event.stopPropagation()">
        <div class="bg-slate-50 p-6 border-b border-slate-200">
            <h3 class="text-xl font-bold text-slate-800 flex items-center gap-2">
                <i class="fa-solid fa-hospital-user text-blue-600"></i> เลือกช่องทางรับบริการ
            </h3>
            <p class="text-slate-500 text-sm mt-1">กรุณาเลือกคลินิกเพื่อส่งตัวผู้ป่วยเข้ารับการตรวจ</p>
        </div>

        <div class="p-6 space-y-3">
            @if(hasInHouseDoctor()) {
            <button (click)="confirmReferralSelection('INTERNAL')"
                class="w-full p-4 border-2 border-emerald-100 bg-emerald-50 hover:bg-emerald-100 hover:border-emerald-300 rounded-xl text-left flex items-center gap-4 transition-all group">
                <div
                    class="w-12 h-12 bg-white rounded-full flex items-center justify-center text-emerald-600 shadow-sm border border-emerald-100 group-hover:scale-110 transition-transform">
                    <i class="fa-solid fa-user-doctor text-2xl"></i>
                </div>
                <div>
                    <p class="font-bold text-emerald-800 text-lg">ตรวจที่สาขานี้ (Internal)</p>
                    <p class="text-emerald-600 text-xs">พบแพทย์ประจำร้าน ผ่านระบบ Video Call หรือ On-site</p>
                </div>
                <i class="fa-solid fa-chevron-right ml-auto text-emerald-400"></i>
            </button>

            <div class="relative flex py-2 items-center">
                <div class="flex-grow border-t border-slate-200"></div>
                <span class="flex-shrink-0 mx-4 text-slate-400 text-xs font-bold uppercase">หรือส่งตัวไปพันธมิตร</span>
                <div class="flex-grow border-t border-slate-200"></div>
            </div>
            }

            @for (partner of activePartners(); track partner.id) {
            <button (click)="confirmReferralSelection(partner)"
                class="w-full p-4 border-2 border-slate-100 bg-white hover:border-blue-300 hover:bg-blue-50 rounded-xl text-left flex items-center gap-4 transition-all group">
                <div
                    class="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 group-hover:bg-blue-100 group-hover:text-blue-600 transition-colors">
                    <i class="fa-solid fa-building-user text-xl"></i>
                </div>
                <div>
                    <p class="font-bold text-slate-700 text-lg group-hover:text-blue-800">{{ partner.partner_name }}</p>
                    <p class="text-slate-400 text-xs group-hover:text-blue-600">คลินิกพันธมิตร (Referral)</p>
                </div>
                <i class="fa-solid fa-arrow-up-right-from-square ml-auto text-slate-300 group-hover:text-blue-400"></i>
            </button>
            }
        </div>

        <div class="p-4 bg-slate-50 border-t flex justify-end">
            <button (click)="showReferralModal.set(false)"
                class="px-6 py-2 text-slate-500 hover:text-slate-800 font-bold">ยกเลิก</button>
        </div>
    </div>
</div>
}
}